// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lU","ratingContainer":"mU","ratingValue":"nU","starSprite":"oU","ratingLabel":"pU","error":"qU","errorBox":"rU"};